import React from 'react'
import * as S from '../../../styles';

const SearchComp = ({searchGuest}) => {
  return (
    <S.SearchInput placeholder='Busque convidados' onChange={(e) => searchGuest(e)}/>
  )
}

export default SearchComp